import React from 'react';
import cn from 'classnames';
import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { toUSD } from 'helpers/NumberFormats';
import css from 'styles/components/checkout/melody/review/digitalItem.scss';

const DigitalItem = (params, { testId }) => {
  const {
    hasGcQuantityCv,
    isFetchingCheckoutData,
    isLast,
    isReviewStep,
    onChangeQuantity,
    product: {
      asin,
      color,
      gcCustomization: { message, recipientEmail, senderName },
      image: { url: imageUrl, alt: imageAlt },
      lineItemId,
      price,
      brandName,
      style
    }
  } = params;

  return (
    <form method="post" action="/tbd" className={css.form}>
      <div className={cn(css.itemWrapper, { [css.last]: isLast, [css.updating]: isFetchingCheckoutData })}>
        { isReviewStep && hasGcQuantityCv && <div className={css.errorBox}><p>You may only have 1 E-Gift Card per purchase.</p></div> }
        <div className={css.contentWrapper}>
          <div>
            <Link
              className={css.imageLink}
              to={`/p/asin/${asin}`}
              data-te="TE_CHECKOUT_REV_GO_TO_PDP"
              data-ted={asin}
              data-test-id={testId('productImage')}>
              <img width="80" src={imageUrl} alt={imageAlt} />
            </Link>
          </div>
          <div>
            <div>
              <div>{brandName}</div>
              <div className={css.itemName}>{style}</div>
              <div>Color: {color}</div>
              <div className={css.break}>Send To: {recipientEmail}</div>
              <div className={css.break}>From: {senderName}</div>
              { !!message && <div className={css.break}>Message: {message}</div> }
              <div className={css.priceLine}>
                <span className={css.price}>{toUSD(price)}</span>
              </div>
            </div>
            <div>
              {
                isReviewStep && <button
                  disabled={isFetchingCheckoutData}
                  type="button"
                  className={css.removeItemBtn}
                  data-test-id={testId('removeItemBtn')}
                  onClick={e => onChangeQuantity(e, lineItemId)}
                  value="0">Remove</button>
              }
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

DigitalItem.contextTypes = {
  testId: PropTypes.func
};

export default DigitalItem;
